"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pubSubMessageEnum = Object.freeze({
  TOPIC_START_LOADIMAGE: "LOADIMAGE_START",
  TOPIC_COMPLETE_LOADIMAGE: "LOADIMAGE_COMPLETE",
  TOPIC_MARKER_ADDED: "MARKER_ADDED",
  TOPIC_MARKER_DELETED: "MARKER_DELETED",
  TOPIC_STANDARD_MARKER_ENABLED: "STANDARD_MARKER_ENABLED",
  TOPIC_STANDARD_MARKER_DISABLED: "STANDARD_MARKER_DISABLED",
  TOPIC_STATE_BROADCAST: "STATE_BROADCAST"
});
var _default = exports.default = pubSubMessageEnum;